module.exports = __webpack_public_path__ + "img/ys.8aecaecd.svg";